import { mcn } from "@/utils/mergeClassNames";
import { useHasDesktopHeader } from "@/utils/useCurrentScreenSize";
import { AnchorLink } from "./AnchorLink";
import { useActiveAnchor } from "./useActiveAnchor";
import { useIsStickingObserver } from "./useIsStickingObserver";

export type AnchorLinkItem = {
  text: string;
  id: string;
};

export type AnchorLinksProps = {
  anchorLinks?: AnchorLinkItem[];
  onRenderRight?: (isSticking: boolean) => JSX.Element;
  className?: string;
};
export const AnchorLinks = ({
  anchorLinks = [],
  onRenderRight,
  className,
}: AnchorLinksProps) => {
  const isDesktop = useHasDesktopHeader();
  const { isSticking, ref } = useIsStickingObserver(isDesktop);
  const { activeIndex } = useActiveAnchor(anchorLinks, isDesktop);
  return (
    <div
      ref={ref}
      className={mcn(
        "sticky z-30",
        "top-site-header-mobile laptop:top-0",
        "flex items-center",
        isSticking && "bg-blue shadow-elevation-3",
        className
      )}
    >
      <div
        className={mcn(
          "container flex items-center h-full",
          "whitespace-nowrap overflow-x-auto overflow-y-hidden",
          "styled-scrollbar"
        )}
      >
        {anchorLinks.map((props, index) => (
          <AnchorLink key={index} active={index === activeIndex} {...props} />
        ))}
        {onRenderRight && (
          <div className="!ml-auto">{onRenderRight(isSticking)}</div>
        )}
      </div>
    </div>
  );
};
